// extracted by mini-css-extract-plugin
module.exports = {"ResizeHandle":"ResizeHandle_ResizeHandle__XCxM7","horizontal":"ResizeHandle_horizontal__MUaYY"};